import Select from 'react-select';
import { states } from 'lib/theraStartConstants';
export default function BusinessDetailsStep({ formik }) {
  const options = states.map((el) => ({
    ...el,
    label: el.State,
    value: el.StateCode,
  }));
  return (
    <div className="">
      <p className="mb-[0.5rem] text-[1.56rem] font-[500] leading-tight text-[#191919] md:whitespace-nowrap">
        Let's Start With Your Business Details
      </p>
      <p className="mb-[0.5rem] text-[1rem] text-light-gray">The first step to pursuing your passion starts here.</p>

      <div className="mb-[1rem]">
        <label htmlFor="businessName" className="mb-[0.5rem] block text-[1rem] font-medium text-[#191919]">
          Enter Your Business Name
        </label>
        <input
          id="businessName"
          name="businessName"
          type="text"
          className={`w-full rounded-lg border bg-white px-[1rem] py-[0.625rem] text-[1rem] text-[#191919] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-therablue ${
            formik.touched.businessName && formik.errors.businessName ? 'border-red-500' : 'border-[#E5E7EB]'
          }`}
          {...formik.getFieldProps('businessName')}
        />
        {formik.touched.businessName && formik.errors.businessName && (
          <div className="mt-[0.25rem] text-[0.875rem] text-red-500">{formik.errors.businessName}</div>
        )}
      </div>

      <div className="mb-[1]">
        <label htmlFor="state" className="mb-[0.5rem] block text-[1rem] font-medium text-[#191919]">
          Select State
        </label>
        <Select
          id="state"
          name="state"
          components={{
            IndicatorSeparator: () => null,
          }}
          menuShouldScrollIntoView={false}
          options={options}
          classNamePrefix="react-select"
          className="no-focus-ring mb-[0.5rem] text-[#11111180]"
          value={options.find((option) => option.value === formik.values.state) || null}
          onChange={(option) => formik.setFieldValue('state', option?.value || '')}
          onBlur={() => formik.setFieldTouched('state', true)}
          placeholder="Select State"
          isSearchable={true}
          styles={{
            control: (base, state) => ({
              ...base,
              width: '100%',
              padding: '0.125rem',
              fontSize: '1rem',
              borderRadius: '0.5rem',
              backgroundColor: 'var(--card)',
              borderColor: formik.touched.state && formik.errors.state ? '#f56565' : 'var(--border)',
              boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.5)' : 'none',
              '&:hover': {
                borderColor: formik.touched.state && formik.errors.state ? '#f56565' : '#a0aec0',
              },
            }),
            placeholder: (base) => ({
              ...base,
              color: 'var(--muted-foreground)',
            }),
            singleValue: (base) => ({
              ...base,
              color: 'var(--foreground)',
            }),
            input: (base) => ({
              ...base,
              color: 'var(--foreground)',
            }),
            menu: (base) => ({
              ...base,
              maxHeight: '12.5rem',
              backgroundColor: 'var(--popover)',
            }),
            menuList: (base) => ({
              ...base,
              maxHeight: '12.5rem',
            }),
            option: (base, optionState) => ({
              ...base,
              backgroundColor: optionState.isSelected
                ? '#2684FF'
                : optionState.isFocused
                  ? 'var(--accent)'
                  : 'var(--popover)',
              color: optionState.isSelected ? '#ffffff' : 'var(--foreground)',
            }),
          }}
        />
        {formik.touched.state && formik.errors.state && (
          <div className="mt-[0.25rem] text-[0.875rem] text-red-500">{formik.errors.state}</div>
        )}
      </div>
    </div>
  );
}
